import React, {Component, Fragment} from 'react'
import {
    Select, message, Input, Table, Button, Popconfirm, Form, DatePicker, Row, Col,
    Upload, Radio, Checkbox, Tooltip, Icon
} from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
//import TrackModel from './preview/trackModel'
import CabinetTypeSelect from "../../components/cabinet-type-select";
import {toStrFixed, subStr} from '../../utills/subStringUtill'
import {
    reqArea, reqAddress, getOrder, getPackages, reqUpdateTrack, savePackage, updatePackage, delPackage, baseUrl,
    reqRentalBox, reqCustomsPorts, reqDeclareCities, reqBusiness, reqCabinInfoStock, reqPayInfo, reqFileList, fileThumb,
    reqCabinInfoCancelTime, reqPlanList, reqVehicleStock, reqTrainInfo
} from '../../api'
import ajax from "../../api/ajax";
import authorizeBase from "../../components/authorize/authorizeBase";
import SelectAreaFormItem from './select-area'
import {handleChangeArea, handleChangeRentalBox, range} from '../../utills/common';
import {YgIcon, fontSize, color, color1Y, color2Y, color3Y, color4Y} from '../../components/yg-icon'
import SelectFormItem from '../../components/select-form-item'
import {convertToRadios} from "../../components/radios";
import {convertToOptions} from "../../components/options";
import {
    DELIVERY_TYPE, TRAIN_PORT_DELIVERY_TYPE, DELIVERY_TYPE_MIX, DELIVERY_TYPE_HIGHWAY, DELIVERY_TYPE_AIR,
    SUB_TYPE, DEFAULT_CUSTOMS_CODE, PLAN_DELIVERY_TYPE
} from "../../utills/constants";

const AuthButton = authorizeBase(Button)
const AuthPopconfirm = authorizeBase(Popconfirm);
const {Option} = Select;
moment.locale('zh-cn');

let orderId = '';

class OrderTrack extends Component {
    constructor(props) {
        super(props);
        this.state = {
            previewVisiable: false,
            action: '',
            packageManageVos: [],
            previewData: {},
            countryDataStart: [],
            stateDataStart: [],
            cityDataStart: [],
            countryDataEnd: [],
            stateDataEnd: [],
            cityDataEnd: [],
            consignorData: [],
            createdDt: "",
            notifyPartyData: [],
            deliveryPlaceData: [],
            origin: [],
            destination: [],
            importList: [],
            consigneeData: [],
            intiCityValue: '阿拉山口',
            intiCountryValue: '中国',
            rentBox: [],
            returnBox: [],
            ownBox: '',
            secondPlace: false,//国内仓库
            secondNotify: false,//清关仓库(通知方)
            secondConsignee: false,//目的仓库(卸货方)
            declareModes: [],
            restStock: null,//剩余舱位数量
            payFlag: false,//是否需要上传凭证
            fileList: [],//支付凭证
            planList: [],//班次时间列表
            vehicleStock: {},//剩余车型数量
            train: {},//企业订舱天数
        }
    }

    componentDidMount() {
        orderId = this.props.location.state.orderId;
        this.getAddress(3);
        this.getAddress(2);
        this.getAddress(1);
        this.getAddress(6);
        this.getDeclareCities();
        this.getCabinInfoCancelTime();
        const track = JSON.parse(sessionStorage.getItem("track"));
        if (track) {
            const deliveryEstimateDt = track.deliveryEstimateDt ? moment(track.deliveryEstimateDt, 'YYYY-MM-DD HH:mm:ss') : null;
            const estimatePortDt = track.estimatePortDt ? moment(track.estimatePortDt, 'YYYY-MM-DD HH:mm:ss') : null;
            const leaveCountryDt = track.leaveCountryDt ? moment(track.leaveCountryDt, 'YYYY-MM-DD HH:mm:ss') : null;
            const trainDt = track.trainDt ? moment(track.trainDt, 'YYYY-MM-DD') : null;
            this.props.form.setFieldsValue({deliveryEstimateDt, leaveCountryDt, trainDt,});
            this.setState(track);
        } else {
            this.initFormData();
        }
    }

    componentWillUnmount() {
        const curData = this.props.form.getFieldsValue();
        delete curData.deliveryEstimateDt;
        delete curData.estimatePortDt;
        const stateData = this.state;
        Object.assign(stateData, curData);
        sessionStorage.setItem('track', JSON.stringify(stateData));
    }

    componentDidUpdate(preProps, preState, snapShot) {
        const {deliveryType, start, international, customsClearance, airStart, airEnd} = this.state;
        if (preState.deliveryType && preState.deliveryType !== deliveryType) {
            if (DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType)) {
                if (deliveryType === 'D' && !(Array.isArray(start) && start.length > 0)) {
                    this.setInitAreaData('', "FS");
                }
                if (!(Array.isArray(international) && international.length > 0)) {
                    this.setInitAreaData('', 'D');
                }
            }
            if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && !(Array.isArray(customsClearance) && customsClearance.length > 0)) {
                this.setInitAreaData('', 'C');
            }
            if (DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType)) {
                if (!(Array.isArray(customsClearance) && customsClearance.length > 0)) {
                    this.setInitAreaData('', 'C');
                }
                if (!(Array.isArray(airStart) && airStart.length > 0)) {
                    this.setInitAreaData('', 'AF');
                }
                if (!(Array.isArray(airEnd) && airEnd.length > 0)) {
                    this.setInitAreaData('', 'AT');
                }
            }
        }
    }

    getCustomsPorts = async (deliveryType) => {
        let result = await reqCustomsPorts({deliveryType});
        if (result.code === 200) {
            this.setState({
                customsPorts: [...result.data],
            })
        } else {
            message.error(result.message)
        }
    }
    getCabinInfoCancelTime = async () => {
        let result = await reqCabinInfoCancelTime();
        if (result.code === 200) {
            this.setState({cancelTime: result.data,})
        } else {
            message.error(result.message)
        }
    }
    getBusiness = async (customsPort, deliveryType) => {
        let result = await reqBusiness(customsPort, deliveryType);
        if (result.code === 200) {
            if (result.data != null && Object.keys(result.data).length > 0) {
                this.setState({declareModes: result.data})
            } else {
                this.setState({declareModes: []})
            }
        } else {
            message.error(result.message)
        }
    };
    //剩余舱位查询
    getCabinInfoStock = async (po) => {
        let result = await reqCabinInfoStock(po);
        if (result.code === 200) {
            this.setState({restStock: result.data})
        } else {
            message.error(result.message)
        }
    }
    //是否需要支付凭证
    getPayInfo = async (po) => {
        let result = await reqPayInfo(po);
        if (result.code === 200) {
            this.setState({payFlag: result.data})
        } else {
            message.error(result.message)
        }
    };
    getDeclareCities = async () => {
        let result = await reqDeclareCities();
        if (result.code === 200) {
            this.setState({
                declareCities: [...result.data],
            })
        } else {
            message.error(result.message)
        }
    }


    judgeReadOnly = orderStatus => {
        if (orderStatus != 'new' && orderStatus != 'failed' && orderStatus != 'audit' && orderStatus != 'audited') {
            return true;
        }
        return false;
    };
    setInitAreaData = async (city, type) => {
        let result = await reqArea(type);
        if (result.code === 200) {
            let preInit;
            if (type === 'F') {
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'originCity', preInit, 'originCountry', 'origin', result.data);
            } else if (type === 'T') {
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'destinationCity', preInit, 'destinationCountry', 'destination', result.data);
            } else if (type === 'FS') {//起始站：亚欧直达
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'airStartCity', preInit, 'airStartCountry', 'start', result.data);
            } else if (type === 'D') {
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'internationalEndCity', preInit, 'internationalEndCountry', 'international', result.data);
            } else if (type === 'C') {
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'customsClearanceCity', preInit, 'customsClearanceCountry', 'customsClearance', result.data);
            } else if (type === 'AF') {//启运机场
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'airStartCity', preInit, 'airStartCountry', 'airStart', result.data);
            } else if (type === 'AT') {//目的机场
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'airEndCity', preInit, 'airEndCountry', 'airEnd', result.data);
            }
        } else {
            message.error(result.message);
        }
    };
    handleChangeDestination = (e) => {
        const data = handleChangeArea(this, 'destinationCity', e, 'destinationCountry', 'destination', null, 'boxReturnStation');
        //剩余舱位
        const {deliveryType, declareMode, transferType,} = this.props.form.getFieldsValue();
        const {estimatePortDt,} = this.state;
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && declareMode && estimatePortDt && data.destinationCountry && transferType) {
            this.getCabinInfoStock({
                deliveryType,
                declareMode,
                estimatePortDt,
                destinationCountry: data.destinationCountry,
                transferType,
            })
        }
        //是否需上传支付凭证
        if (deliveryType && declareMode && data.destinationCountry) {
            this.getPayInfo({deliveryType, declareMode, destinationCountry: data.destinationCountry})
        }
    };
    //租箱地rent_box,还箱地return_box
    setInitRentalBoxData = async (stationValue, type) => {
        let result = await reqRentalBox(type);
        if (result.code === 200) {
            if (type === 'rent_box') {
                handleChangeRentalBox(this, 'boxRentStation', stationValue, 'rentBox', result.data)
            } else if (type === 'return_box') {
                handleChangeRentalBox(this, 'boxReturnStation', stationValue, 'returnBox', result.data);
            }
        } else {
            message.error(result.message);
        }
    };
// 获取国家数据
    /* getCountryData = async (initData, type) => {
     const {setFieldsValue} = this.props.form;
     let result = await reqCountry();
     if (result.code === 200) {
     const countryData = result.data;
     const preInit = initData.countryId ? initData.countryId : countryData.map((pre) => {
     if (pre.id) {
     return pre.id
     } else {
     return ''
     }
     })[0];
     const item = countryData.find(item => preInit === item.id);
     if (item) {
     if (type === 1) {
     this.setState({
     countryDataStart: countryData
     });
     setFieldsValue({originCountryId: preInit});

     if (item.complex == 2) {
     this.getCityData(preInit, initData.cityId, 1)
     } else {
     this.getStateData(preInit, initData, 1)
     }

     } else {
     this.setState({
     countryDataEnd: countryData
     });
     setFieldsValue({destinationCountryId: preInit});
     if (item.complex == 2) {
     this.getCityData(preInit, initData.cityId, 2)
     } else {
     this.getStateData(preInit, initData, 2)
     }
     }
     }
     }
     };*/
//国家 省 城市 三级联动
    /*handleCountryChange = value => {
     const {setFieldsValue} = this.props.form;
     const {countryDataStart} = this.state;
     const item = countryDataStart.find(item => value === item.id);
     if (item) {
     if (item.complex == 2) {
     this.getCityData(value, '', 1);
     this.setState({
     stateDataStart: [],
     })
     setFieldsValue({originProvinceId: ''});
     } else {
     this.getStateData(value, {}, 1);
     this.setState({
     cityDataStart: []
     })
     }

     }

     };

     handleStateChange = value => {
     this.getCityData(value, '', 1)
     };

     handleCountryChange2 = value => {
     const {setFieldsValue} = this.props.form;
     const {countryDataEnd} = this.state;
     const item = countryDataEnd.find(item => value === item.id);
     if (item) {
     if (item.complex == 2) {
     this.getCityData(value, '', 2);
     this.setState({
     stateDataEnd: [],
     });
     setFieldsValue({destinationProvinceId: ''});
     } else {
     this.getStateData(value, {}, 2);
     this.setState({
     cityDataEnd: []
     })
     }

     }
     };

     handleStateChange2 = value => {
     this.getCityData(value, '', 2)
     };

     // 获取省级数据

     getStateData = async (parentId, initData, type) => {
     const {setFieldsValue} = this.props.form;
     let result = await reqState(parentId);
     if (result.code === 200) {
     const stateData = result.data;
     const preInit = initData.stateId ? initData.stateId : stateData.map((pre) => {
     if (pre.id) {
     return pre.id
     } else {
     return ''
     }
     })[0];
     if (type === 1) {
     if (stateData.length > 0) {
     this.setState({
     stateDataStart: stateData,
     });
     setFieldsValue({originProvinceId: preInit});
     this.getCityData(preInit, initData.cityId, type)
     } else {
     this.setState({
     stateDataStart: [],
     cityDataStart: [],
     });
     setFieldsValue({originProvinceId: ''});
     setFieldsValue({originCityId: ''})
     }
     } else {
     if (stateData.length > 0) {
     this.setState({
     stateDataEnd: stateData,
     });
     setFieldsValue({destinationProvinceId: preInit});
     this.getCityData(preInit, initData.cityId, type)
     } else {
     this.setState({
     stateDataEnd: [],
     cityDataEnd: [],
     });
     setFieldsValue({destinationProvinceId: ''});
     setFieldsValue({destinationCityId: ''})
     }
     }


     }
     };

     // 获取市级数据

     getCityData = async (parentId, cityId, type) => {
     const {setFieldsValue} = this.props.form;
     let result = await reqCity(parentId);
     if (result.code === 200) {
     const cityData = result.data;
     const cityInit = cityId ? cityId : cityData.map((pre) => {
     if (pre.id) {
     return pre.id
     }
     })[0];
     if (type === 2) {
     if (cityData) {
     this.setState({
     cityDataEnd: cityData
     });
     setFieldsValue({destinationCityId: cityInit})
     } else {
     setFieldsValue({destinationCityId: ''})
     }
     } else {
     if (cityData) {
     this.setState({
     cityDataStart: cityData
     });
     setFieldsValue({originCityId: cityInit})
     } else {
     setFieldsValue({originCityId: ''})
     }
     }

     }
     };*/
// 获取地址信息
    getAddress = async (type) => {
        let result = await reqAddress(type, orderId);
        const res = result.data;
        if (result.code === 200) {
            if (res.length > 0) {
                const originData = res.map((pre) => {
                    return {
                        id: pre.id,
                        address: pre.address,
                        state: pre.state,
                        country: pre.country,
                        city: pre.city,
                        name: pre.company,
                        phone: pre.phone,
                        contact: pre.contact
                    }
                })[0];
                const {address, tel} = this.getInformation(originData);
                if (type === 3) {
                    this.setState({
                        deliveryPlaceData: res,
                        deliveryPlaceId: originData.id,
                        deliveryPlaceName: originData.name,
                        deliveryPlaceAddress: address,
                        deliveryPlacePhone: originData.phone,
                        deliveryPlaceContact: originData.contact
                    })
                } else if (type === 2) {
                    this.setState({
                        notifyPartyData: res,
                        notifyPartyId: originData.id,
                        notifyPartyName: originData.name,
                        notifyPartyAddress: address,
                        notifyPartyContact: originData.contact,
                    })
                } else if (type === 1) {
                    this.setState({
                        consignorData: res,
                        consignorId: originData.id,
                        consignorName: originData.name,
                        consignorAddress: address
                    })
                } else if (type === 6) {
                    this.setState({
                        consigneeData: res,
                        consignee: originData.name,
                        consigneeAddr: address,
                        consigneeContact: originData.contact,
                        consigneeTel: tel.toString()
                    })
                }
            }
        }
    };
    getInformation = (o) => {
        const address = (o.country ? o.country : '') + (o.state ? o.state : '') + (o.city ? o.city : '') + o.address;
        const tel = [];
        if (o.phone) {
            tel.push(o.phone)
        }
        if (o.email) {
            tel.push(o.email)
        }
        return {address, tel}
    };
// 发货人变化时
    handleconsignorChange = (key) => {
        const {consignorData} = this.state;
        consignorData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    shipper: o.company,
                    shipperAddr: address,
                    shipperContact: o.contact,
                    shipperTel: tel.toString()
                })
            }
        })
    };
    consigneeHandleChange = (addrId) => {
        const {consigneeData} = this.state;
        consigneeData.map(o => {
            if (o.id == addrId) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    consignee: o.company,
                    consigneeAddr: address,
                    consigneeContact: o.contact,
                    consigneeTel: tel.toString(),
                    consigneeCustomsCode: o.customsCode
                });
                this.handleChangeSame(this.state.sameConsignee);
            }
        })
    };
    consigneeHandleChange2 = (addrId) => {
        const {consigneeData} = this.state;
        consigneeData.map(o => {
            if (o.id == addrId) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    consignee2: o.company,
                    consigneeAddr2: address,
                    consigneeContact2: o.contact,
                    consigneeTel2: tel.toString(),
                    consigneeCustomsCode2: o.customsCode
                });
                this.handleChangeSame(this.state.sameConsignee);
            }
        })
    };
    // 通知方变化时
    handlenotifyPartyChange = (key) => {
        const {notifyPartyData} = this.state;
        notifyPartyData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    notifyParty: o.company,
                    notifyPartyAddr: address,
                    notifyPartyContact: o.contact,
                    notifyPartyTel: tel.toString(),
                    notifyPartyCustomsCode: o.customsCode
                })
            }
        })
    };
    // 通知方变化时2
    handlenotifyPartyChange2 = (key) => {
        const {notifyPartyData} = this.state;
        notifyPartyData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    notifyParty2: o.company,
                    notifyPartyAddr2: address,
                    notifyPartyContact2: o.contact,
                    notifyPartyTel2: tel.toString(),
                    notifyPartyCustomsCode2: o.customsCode
                })
            }
        })
    };
    // 提货方变化时
    handledeliveryPlaceChange = (key) => {
        const {deliveryPlaceData} = this.state;
        deliveryPlaceData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    deliveryPlace: address,
                    contact: o.contact,
                    contactTel: tel.toString()
                })
            }
        })
    };
    // 提货方变化时
    handledeliveryPlaceChange2 = (key) => {
        const {deliveryPlaceData} = this.state;
        deliveryPlaceData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    deliveryPlace2: address,
                    contact2: o.contact,
                    contactTel2: tel.toString()
                })
            }
        })
    };
    // 日期选择
    onDateChange = (current, dateString) => {
        this.setState({deliveryEstimateDt: dateString})
        const {deliveryType} = this.state;
        if (!DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && current) {
            //年月日
            const dateStart = moment().add('days', 6).startOf('day');
            if (current < dateStart) {
                current.add('days', 6);
                dateString = current.format('YYYY-MM-DD HH');
            }
            //小时
            const dateEnd = moment().add('days', 6).endOf('day');
            if (current < dateEnd) {
                const hour = new Date().getHours();
                if (current.hour() <= hour) {
                    current.hour(hour + 1);
                    dateString = current.format('YYYY-MM-DD HH');
                }
            }
        }
        //剩余车型数量
        if (current) {
            this.getVehicleStock({deliveryType, deliveryEstimateDt: dateString,});
        }
    };
    disabledStartDate = (current) => {
        const {deliveryType} = this.state;
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType)) {
            return current && current < moment().endOf('day');
        } else {
            return current && current < moment().add('days', 5).endOf('day');
        }
    };
    disabledDateTime = (current) => {
        const {deliveryType} = this.state;
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType)) {
            return false
        } else {
            if (current && current < moment().add('days', 6).endOf('day')) {
                const hour = new Date().getHours();
                return {
                    disabledHours: () => range(0, hour + 1),
                };
            }
        }
    };
    //预计到达口岸日期选择:只有公路有预计到达口岸
    handleChangeEstimatePortDt = (current, dateString) => {
        this.setState({estimatePortDt: dateString})
        //剩余舱位
        const {deliveryType, transferType, declareMode} = this.props.form.getFieldsValue();
        const {destinationCountry,} = this.state;
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && declareMode && current && destinationCountry && transferType) {
            this.getCabinInfoStock({
                deliveryType,
                declareMode,
                estimatePortDt: dateString,
                destinationCountry,
                transferType,
            })
        }
    };
    //预计出境日期选择
    disabledLeaveCountryDt = (current) => {
        const {train} = this.state;
        //提前天数
        const preDay = moment().add('days', train.monthDay - 1).endOf('day');
        //当月最后一天
        const lastDay = moment().endOf('month');
        // a.预计出境日期 - 当前日期 ≥ 10。
        const a = current < moment().add('days', 9).endOf('day');
        // b.当前日期 + 提前天数如果日期仍为当月，则预计出境日期只能选本月。
        const b = current > lastDay;
        // c.下月最后一天
        const c = current > moment().add('month', 1).endOf('month');
        if (preDay < lastDay) {
            return a || b
        } else {
            return a || c
        }
    };
    //班次时间查询
    getPlanList = async (deliveryType) => {
        let result = await reqPlanList(deliveryType);
        if (result.code === 200) {
            const planList = {};
            result.data.forEach((o, i) => {
                const planDt = subStr(o.planDt)
                planList[planDt] = planDt + '(余' + o.otherCount + ')';
            })
            this.setState({planList})
        } else {
            message.error(result.message)
        }
    }
    //剩余车型数量
    getVehicleStock = async (data) => {
        let result = await reqVehicleStock(data);
        if (result.code === 200) {
            if (result.data) {
                const vehicleStock = {};
                for (let key in result.data) {
                    vehicleStock[key] = result.data[key] ? key + '(剩余' + result.data[key] + ')' : key;
                }
                this.setState({vehicleStock})
            }
        } else {
            message.error(result.message)
        }
    }
    //企业订舱天数
    getTrainInfo = async (deliveryType) => {
        let result = await reqTrainInfo({deliveryType});
        if (result.code === 200) {
            this.setState({train: result.data})
        } else {
            message.error(result.message)
        }
    };
    // 表单数据初始化
    initFormData = async () => {
        const {setFieldsValue} = this.props.form;
        let result = await getOrder(orderId);
        if (result.code === 200) {
            this.getCustomsPorts(result.data.deliveryType);
            let fArea = this.setInitAreaData(result.data.originCity, "F");
            let tArea = this.setInitAreaData(result.data.destinationCity, "T");
            if (DELIVERY_TYPE_MIX.hasOwnProperty(result.data.deliveryType)) {
                if (result.data.deliveryType === 'D') {
                    this.setInitAreaData(result.data.airStartCity, "FS");
                }
                this.setInitAreaData(result.data.internationalEndCity, "D");
            } else if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(result.data.deliveryType)) {
                this.setInitAreaData(result.data.customsClearanceCity, "C");
                //剩余舱位
                this.getCabinInfoStock({
                    deliveryType: result.data.deliveryType,
                    declareMode: result.data.declareMode,
                    estimatePortDt: result.data.estimatePortDt,
                    destinationCountry: result.data.destinationCountry,
                    transferType: result.data.transferType,
                });
            } else {
                this.setInitAreaData(result.data.customsClearanceCity, "C");
                this.setInitAreaData(result.data.airStartCity, 'AF');
                this.setInitAreaData(result.data.internationalEndCity, 'AT');
            }
            let rentBox = this.setInitRentalBoxData(result.data.boxRentStation, "rent_box");
            let returnBox = this.setInitRentalBoxData(result.data.boxReturnStation, "return_box");
            /* console.log('fArea')
             console.log(fArea)
             Promise.all([fArea, rentBox]).then(function (results) {
             console.log(results)
             });
             Promise.all([tArea, returnBox]).then(function (results) {
             console.log(results)
             });*/
            this.getBusiness(result.data.customsPort, result.data.deliveryType);
            //是否需上传支付凭证
            this.getPayInfo({
                deliveryType: result.data.deliveryType,
                declareMode: result.data.declareMode,
                destinationCountry: result.data.destinationCountry,
            });
            this.getFileList({orderId: orderId, objectType: 'payInfo'});
            //班次时间
            if (PLAN_DELIVERY_TYPE.hasOwnProperty(result.data.deliveryType)) {
                this.getPlanList(result.data.deliveryType)
            }
            //剩余车型数量
            if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(result.data.deliveryType) && result.data.deliveryType !== 'M' && (result.data.transferType === 'w2w' || result.data.transferType === 's2w') && result.data.deliveryEstimateDt) {
                this.getVehicleStock({
                    deliveryType: result.data.deliveryType,
                    deliveryEstimateDt: result.data.deliveryEstimateDt,
                });
            }
            //企业订舱天数：公铁联运、霍欧中铁班车
            if (TRAIN_PORT_DELIVERY_TYPE.hasOwnProperty(result.data.deliveryType)) {
                this.getTrainInfo(result.data.deliveryType)
            }
            //转关运输时，设置报关地必填
            this.handleDeclareMode(result.data.declareMode);
            let deliveryEstimateDt = result.data.deliveryEstimateDt ? result.data.deliveryEstimateDt.substr(0, 13) : '';
            result.data.deliveryEstimateDt = deliveryEstimateDt;
            this.setState({
                readOnly: this.judgeReadOnly(result.data.orderStatus),
                ...result.data,
                secondPlace: result.data.deliveryPlace2 != null,
                secondNotify: result.data.consigneeAddr2 != null,
                secondConsignee: result.data.consigneeAddr2 != null,
            });
            setFieldsValue({
                deliveryEstimateDt: result.data.deliveryEstimateDt ? moment(result.data.deliveryEstimateDt, 'YYYY-MM-DD HH:mm:ss') : null,
                estimatePortDt: result.data.estimatePortDt ? moment(result.data.estimatePortDt, 'YYYY-MM-DD HH:mm:ss') : null,
                leaveCountryDt: result.data.leaveCountryDt ? moment(result.data.leaveCountryDt, 'YYYY-MM-DD HH:mm:ss') : null,
                trainDt: result.data.trainDt ? moment(result.data.trainDt, 'YYYY-MM-DD HH:mm:ss') : null,
            });
        } else {
            message.error(result.message)
        }
    };
    goods = async (orderId, page = 1, pageSize = 20) => {
        let result = await getPackages({orderId, pageNum: page, pageSize});
        if (result.code === 200) {
            if (result.data) {
                this.setState({
                    page,
                    pageSize,
                    total: result.data.total,
                    packageManageVos: result.data.rows,
                })
            }
        } else {
            message.error(result.message)
            return false;
        }
    };
//显示弹窗
    showModal = () => {
        const count = this.state.count + 1;
        this.setState({
            editVisiable: true,
            updateKey: count,
            count: count,
            action: 'add'
        });
    };

//下载PDF
    downloadPdf = () => {
        let name = "order";
        window.location.href = baseUrl + "/api/v1/p/file/fileDownload?id=" + orderId + "&name=" + name;
    };


//显示弹窗
    previewShowModal = () => {
        let previewData = this.state;
        let formData = this.props.form.getFieldsValue();
        delete formData.deliveryEstimateDt;
        previewData = Object.assign(previewData, formData);
        this.setState({
            previewVisiable: true,
            previewData: previewData
        });
    };


//显示弹窗
    editDataSource = (data) => {
        this.setState({
            editVisiable: true,
            updateKey: data.key,
            action: 'edit'
        });
        this.child.props.form.setFieldsValue(data);
    };

//取消弹窗
    hideModal = () => {
        this.setState({
            editVisiable: false,
        })
    };
//取消弹窗
    previewhideModal = () => {
        this.setState({
            previewVisiable: false,
        })
    };
//储存数据
    saveData = async (updateData) => {
        const {action, page, pageSize} = this.state;
        updateData.orderId = orderId;
        if (updateData.value !== undefined && updateData.pcsNumber !== undefined) {
            updateData.totalValue = toStrFixed(updateData.value * updateData.pcsNumber);
        }
        if (action === 'add') {
            let result = await savePackage(updateData);
            if (result.code == 201) {
                this.goods(orderId, page, pageSize);
            } else {
                message.error(result.message);
            }
        } else {
            let result = await updatePackage(updateData);
            if (result.code == 200) {
                this.goods(orderId, page, pageSize);
            } else {
                message.error(result.message);
            }
        }
    };
    onChange = value => {
        // console.log(value);
    };

    onRef = (ref) => {
        this.child = ref
    };

    handleDelete = async (id) => {
        let result = await delPackage(id, orderId);
        if (result.code == 200) {
            this.goods(orderId);
        } else {
            message.error(result.message);
        }
    };

    handleSubmit = (e, isCommit) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            const {packageManageVos, deliveryEstimateDt, estimatePortDt,} = this.state;
            /*if(packageManageVos.length===0){
             return message.error("请填写商品信息")
             }*/
            if (err) {
                return;
            } else {
                values.id = orderId;
                values.deliveryEstimateDt = deliveryEstimateDt;
                values.estimatePortDt = estimatePortDt;
                values.leaveCountryDt = values.leaveCountryDt ? values.leaveCountryDt.format('YYYY-MM-DD') : '';
                values.trainDt = values.trainDt ? values.trainDt.format('YYYY-MM-DD') : '';
                /*二连浩特修改 */
                values.originCountry = this.state.originCountry;
                values.originEndCountry = this.state.intiCountryValue;
                values.originEndCity = this.state.customsPorts.filter(c => c.customsPortCode === values.customsPort)[0].customsPortName;
                if (values.internationalEndCity) {
                    values.internationalEndCountry = this.state.internationalEndCountry;
                }
                if (values.customsClearanceCity) {
                    values.customsClearanceCountry = this.state.customsClearanceCountry;
                }
                if (values.airStartCity) {//启运机场
                    values.airStartCountry = this.state.airStartCountry;
                }
                if (values.airEndCity) {//目的机场
                    values.internationalEndCity = this.state.airEndCity;
                    values.internationalEndCountry = this.state.airEndCountry;
                }
                values.destinationCountry = this.state.destinationCountry;
                /*二连浩特修改 */
                delete values.packageType;
                if (values.boxRentStation === undefined) {
                    values.boxRentStation = ''
                }
                if (values.boxReturnStation === undefined) {
                    values.boxReturnStation = ''
                }
                values.isCommit = isCommit;
                values.supplierList = [];
                this.saveTrackData(values);
            }
        });
    };

    saveTrackData = async (data) => {
        let result = await reqUpdateTrack(data);
        if (result.code === 200) {
            this.props.history.replace('/trackList')
        } else {
            message.error(result.message)
        }
    };


// 发货人变化时
    consigneeTelChange = e => {
        this.setState(
            {
                consigneeTel: e.target.value
            }
        )
    }

    consigneeChange = e => {
        this.setState(
            {
                consignee: e.target.value
            }
        )
    }

    consigneeAddrChange = e => {
        this.setState(
            {
                consigneeAddr: e.target.value
            }
        )
    }
    consigneeContactChange = e => {
        this.setState(
            {
                consigneeContact: e.target.value
            }
        )
    }
    importChange = info => {
        let fileList = [...info.fileList];
        let complete = 0;
        fileList = fileList.map(file => {
            if (file.response) {
                // Component will show file.url as link
                if (file.response.code === 200) {
                    message.info(file.response.message);
                    this.goods(orderId);
                } else if (file.response.code === 205) {
                    message.error(file.response.message)
                    window.location.href = baseUrl + '/' + file.response.data;
                } else {
                    message.error(file.response.message)
                }
                file.status = 'done';
                complete = 1;
            }
            return file;
        });
        if (complete === 1) {
            this.setState({
                importList: []
            })
        } else {
            this.setState({importList: fileList});
        }
    };

    downloadModel = () => {
        window.location.href = baseUrl.replace('/oms', '/upload') + '/template/货物管理导入模板.xlsx';
    }
    search = e => {
        e.preventDefault();
        const {page, pageSize} = this.state;
        this.goods(orderId, page, pageSize);
    };
    handleChangeSame = (checked) => {
        if (checked) {
            const {
                notifyParty, notifyPartyAddr, notifyPartyContact, notifyPartyTel, notifyPartyCustomsCode,
                notifyParty2, notifyPartyAddr2, notifyPartyContact2, notifyPartyTel2, notifyPartyCustomsCode2,
            } = this.props.form.getFieldsValue();
            this.setState({secondConsignee: this.state.secondNotify}, function () {
                this.props.form.setFieldsValue({
                    consignee: notifyParty,
                    consigneeAddr: notifyPartyAddr,
                    consigneeContact: notifyPartyContact,
                    consigneeTel: notifyPartyTel,
                    consigneeCustomsCode: notifyPartyCustomsCode,
                    consignee2: notifyParty2,
                    consigneeAddr2: notifyPartyAddr2,
                    consigneeContact2: notifyPartyContact2,
                    consigneeTel2: notifyPartyTel2,
                    consigneeCustomsCode2: notifyPartyCustomsCode2,
                });
            })
        }
        this.setState({sameConsignee: checked})
    };
    handleCustomsPort = (e, deliveryType) => {
        this.setState({customsPort: e,});
        this.getBusiness(e, deliveryType ? deliveryType : this.state.deliveryType);
        this.props.form.setFieldsValue({declareMode: '', customsPort: e});
    };
    handleDeclareMode = (value) => {
        let declareCityRequired = false;
        if (value === '转关运输') {
            declareCityRequired = true;
        }
        this.setState({declareCityRequired});
        //剩余舱位
        const {deliveryType, transferType,} = this.props.form.getFieldsValue();
        const {destinationCountry, estimatePortDt} = this.state;
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && value && estimatePortDt && destinationCountry && transferType) {
            this.getCabinInfoStock({
                deliveryType,
                declareMode: value,
                estimatePortDt,
                destinationCountry,
                transferType,
            })
        }
        //是否需上传支付凭证
        if (deliveryType && value && destinationCountry) {
            this.getPayInfo({deliveryType, declareMode: value, destinationCountry})
        }
    }
    handleDeliveryType = (value) => {
        message.info('您已选择' + DELIVERY_TYPE[value]);
        this.setState({deliveryType: value,});
        const {subType, transferType, start, airStart} = this.state;
        //服务模式
        if (DELIVERY_TYPE_MIX.hasOwnProperty(value) || value === 'M') {
            this.props.form.setFieldsValue({subType: null,});
            this.setState({subType: null,});
        } else {
            if (!subType) {
                this.props.form.setFieldsValue({subType: 'A',});
                this.setState({subType: 'A',});
            }
        }
        if (DELIVERY_TYPE_MIX.hasOwnProperty(value) || DELIVERY_TYPE_HIGHWAY.hasOwnProperty(value)) {
            this.props.form.setFieldsValue({transferType: 'w2w',});
            this.handleTransferType('w2w');
        }
        if (DELIVERY_TYPE_AIR.hasOwnProperty(value)) {//默认口岸到启运机场
            this.props.form.setFieldsValue({transferType: 'p2as',});
            this.handleTransferType('p2as');
        }
        //出境口岸
        this.getCustomsPorts(value);
        //根据口岸请求货物类型
        this.handleCustomsPort(DEFAULT_CUSTOMS_CODE[value], value);
        //起始站、启运机场默认值
        if (DELIVERY_TYPE_AIR.hasOwnProperty(value)) {
            this.props.form.setFieldsValue({airStartCity: Array.isArray(airStart) && airStart.length > 0 ? airStart[0].cityName : ''});
        } else {
            this.props.form.setFieldsValue({airStartCity: Array.isArray(start) && start.length > 0 ? start[0].cityName : ''});
        }
        const {declareMode,} = this.props.form.getFieldsValue();
        const {destinationCountry, deliveryEstimateDt, estimatePortDt,} = this.state;
        //预计提货时间
        this.props.form.setFieldsValue({deliveryEstimateDt: null});
        //剩余舱位
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(value) && declareMode && estimatePortDt && destinationCountry && transferType) {
            this.getCabinInfoStock({
                deliveryType: value,
                declareMode,
                estimatePortDt,
                destinationCountry,
                transferType,
            })
        }
        //是否需上传支付凭证
        if (value && declareMode) {
            this.getPayInfo({deliveryType: value, declareMode, destinationCountry})
        }
        //班次时间
        if (PLAN_DELIVERY_TYPE.hasOwnProperty(value)) {
            this.getPlanList(value)
        }
        //车型
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(value) && value !== 'M' && (transferType === 'w2w' || transferType === 's2w') && deliveryEstimateDt) {
            this.getVehicleStock({deliveryType: value, deliveryEstimateDt});
            this.props.form.setFieldsValue({vehicleType: null})
        }
        //企业订舱天数：霍欧中铁班车
        if (TRAIN_PORT_DELIVERY_TYPE.hasOwnProperty(value)) {
            this.getTrainInfo(value)
        }
    }
    handOwnBox = (e) => {
        this.setState({ownBox: e.target.value})
    }
    handleTransferType = (value) => {
        //剩余舱位
        const {deliveryType, declareMode,} = this.props.form.getFieldsValue();
        const {destinationCountry, deliveryEstimateDt, estimatePortDt,} = this.state;
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && declareMode && estimatePortDt && destinationCountry && value) {
            this.getCabinInfoStock({
                deliveryType,
                declareMode,
                estimatePortDt,
                destinationCountry,
                transferType: value,
            })
        }
        //车型
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && deliveryType !== 'M' && (value === 'w2w' || value === 's2w') && deliveryEstimateDt) {
            this.getVehicleStock({deliveryType, deliveryEstimateDt,})
        }
        this.setState({transferType: value,})
    }
    //上传支付凭证
    getFileList = async (po) => {
        po.pageNum = 1;
        po.pageSize = 100;
        let result = await reqFileList(po);
        if (result.code === 200) {
            const fileList = result.data.rows;
            let showFiles = [];
            fileList.forEach((item, index) => {
                item.uid = index;
                item.name = item.fileName;
                item.thumbUrl = this.getThumbUrl(item.fileName)
                item.url = baseUrl + '/' + item.filePath;
                showFiles.push(item);
            });
            this.setState({
                fileList: showFiles
            })
        } else {
            message.error(result.message)
        }

    }
    handleRemove = info => {
        let result = ajax(baseUrl + '/api/v1/p/file/fileDel', {"fileId": info.id, "orderId": orderId}, 'DELETE');
        const _this = this;
        result.then(function (value) {
            if (value.code === 200) {
                return true;
            } else {
                _this.getFileList({orderId: orderId, objectType: 'payInfo'});
                message.error(value.message)
            }
        }, function (error) {
            message.error(error)
        });

    };
    handleChange = info => {
        let fileList = [...info.fileList];
        fileList = fileList.map(file => {
            if (file.response) {
                // Component will show file.url as link
                if (file.response.code === 200) {
                    file.thumbUrl = this.getThumbUrl(file.response.data.fileName)
                    file.url = baseUrl + '/' + file.response.data.filePath;
                    file.id = file.response.data.id;
                } else {
                    file.status = 'error';
                    file.response = file.response.message;
                    // message.error(file.response.message);
                }
            }
            return file;
        });

        this.setState({fileList});
    };
    getThumbUrl = (fileName) => {
        let thumbUrl = ""
        if (fileName.toLowerCase().endsWith(".docx") || fileName.toLowerCase().endsWith(".doc")) {
            thumbUrl = fileThumb.word
        } else if (fileName.toLowerCase().endsWith(".xlsx") || fileName.toLowerCase().endsWith(".xls")) {
            thumbUrl = fileThumb.excel
        } else if (fileName.toLowerCase().endsWith(".pdf")) {
            thumbUrl = fileThumb.pdf
        }
        return thumbUrl
    }

    render() {
        const {getFieldDecorator, getFieldValue, setFieldsValue} = this.props.form;
        const formItemLayout = {
            labelCol: {span: 8},
            wrapperCol: {span: 14}
        };
        /*const uploadProps = {
         name: 'file',
         action: baseUrl + '/api/v1/p/oms/import',
         withCredentials: true,
         onChange: this.importChange,
         showUploadList: false,
         fileList: this.state.importList,
         accept: ".xls,.xlsx,application/vnd.ms-excel",
         };*/
        const {
            notifyPartyData, deliveryPlaceData, transferType, deliveryType, subType,
            insureFeeType, transitFeeType, ownBox, secondPlace, secondNotify, secondConsignee, readOnly,
            payFlag, cancelTime, vehicleStock
        } = this.state;
        const uploadProps = {
            name: 'file',
            action: baseUrl + '/api/v1/p/file/upLoad?objectType=payInfo&orderId=' + orderId,
            onChange: this.handleChange,
            onRemove: this.handleRemove,
            multiple: false,
            listType: 'picture',
            withCredentials: true,
            onPreview: this.handlePreview,
            beforeUpload: this.handleBeforeUpload,
            showUploadList: {showDownloadIcon: false}
        };
        /* const columns = [
         {
         title: '唛码标记Marks',
         dataIndex: 'boxNo',
         }, {
         title: '品名(中文)',
         dataIndex: 'name',
         }, {
         title: '品名(英文)',
         dataIndex: 'nameEn',
         }, {
         title: '国内HSCode',
         dataIndex: 'hscode',
         }, {
         title: '国外HSCode',
         dataIndex: 'oHscode',
         }, {
         title: '箱数CTNS',
         dataIndex: 'num',
         }, {
         title: '件数PCS',
         dataIndex: 'pcsNumber',
         }, {
         title: '毛重(Kg)',
         dataIndex: 'grossWeight',
         }, {
         title: '净重(Kg)',
         dataIndex: 'netWeight',
         }, {
         title: '体积(CBM)',
         dataIndex: 'volume',
         }, {
         title: '单价/币制Value unit',
         dataIndex: 'value',
         render: (text, record) => {
         if (text === undefined || text === null) {
         return
         } else {
         return text + '/' + record.currency;
         }
         }
         }, {
         title: '总价/币制Value & Currency',
         dataIndex: 'totalValue',
         render: (text, record) => {
         if (text === undefined || text === null) {
         return
         } else {
         return text + '/' + record.currency;
         }
         }
         }, {
         title: '成分',
         dataIndex: 'ingredient',
         }, {
         title: '用途',
         dataIndex: 'application',
         }, {
         title: '操作',
         dataIndex: 'opt',
         render: (text, record) => {
         return (
         <span> <a onClick={() => this.editDataSource(record)}
         style={{marginRight: 8}}>
         修改
         </a>
         <Popconfirm title="是否确定删除?" onConfirm={() => this.handleDelete(record.id)}>
         <a>删除</a>
         </Popconfirm>
         </span>
         );
         }
         }
         ];*/
        const radios = [];
        for (let key in SUB_TYPE) {
            if (key === 'A') {
                radios.push(<Radio key={key} value={key}>{SUB_TYPE[key]}&nbsp;
                    <Tooltip title="以国际标准集装箱为载货容器，为委托方提供自中国境内仓库装箱后运输至中亚及欧洲一站式运输服务，途中不更换载货容器。">
                        <YgIcon type="icon-wenhaow"/>
                    </Tooltip>
                </Radio>)
            } else {
                radios.push(<Radio key={key} value={key}>{SUB_TYPE[key]}&nbsp;
                    <Tooltip title="使用厢式货车载运国内货物至边境口岸后，将出口货物倒装至“跨境集装器”后摆渡过境，在境外将“跨境集装器”中货物倒装至二次倒装至厢式货车，并完成境外全程运输任务。">
                        <YgIcon type="icon-wenhaow"/>
                    </Tooltip>
                </Radio>)
            }
        }
        //国内仓库、目的仓库非必填：公路和空运的口岸服务
        const whRequired = DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) || transferType !== 'p2p';
        //清关仓库非必填：公路的口岸服务、空运
        const declareWhRequired = !(DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && transferType === 'p2p')
            && !DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType);
        return (
            <div className='order-space'>
                <Form onSubmit={e => this.handleSubmit(e, 'N')} autoComplete='off' {...formItemLayout}>
                    <div className="order-base-title">
                        基本信息
                    </div>
                    <div className="order-spaceInfo-content">
                        <Row className='Row route-planning-before'>
                            <Col span={24}>
                                <Form.Item label="运输类型" {...{
                                    labelCol: {span: 6,},
                                    wrapperCol: {span: 18}
                                }}>{getFieldDecorator('deliveryType', {
                                    initialValue: deliveryType,
                                    rules: [{required: true, message: '该项必填'}]
                                })(<Radio.Group disabled={this.state.readOnly}
                                                onChange={e => this.handleDeliveryType(e.target.value)}>
                                    {convertToRadios(DELIVERY_TYPE)}
                                </Radio.Group>)}
                                </Form.Item>
                            </Col>
                            {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && deliveryType !== 'M' ?
                                <Col span={24}>
                                    <Form.Item label="服务类型" {...{
                                        labelCol: {span: 6,},
                                        wrapperCol: {span: 18}
                                    }}>{getFieldDecorator('subType', {
                                        initialValue: subType,
                                        rules: [{required: true, message: '该项必填'}]
                                    })(<Radio.Group disabled={this.state.readOnly}
                                                    onChange={e => this.setState({subType: e.target.value})}>
                                        {radios}
                                    </Radio.Group>)}
                                    </Form.Item> </Col> : null}
                            <Col span={24}>
                                <Form.Item label="委托方式" {...{
                                    labelCol: {span: 6,},
                                    wrapperCol: {span: 18}
                                }}>{getFieldDecorator('transferType', {
                                    initialValue: transferType,
                                    rules: [{required: true, message: '该项必填'}]
                                })(<Radio.Group disabled={this.state.readOnly}
                                                onChange={e => this.handleTransferType(e.target.value)}>
                                    <Radio value='w2w'>仓到仓 <Tooltip title="全程都由我司承运。">
                                        <YgIcon type="icon-wenhaow"/>
                                    </Tooltip>{/*<br/><span className="tips-label">最省心</span>*/}</Radio>
                                    {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                                        (deliveryType === 'D' ?
                                            <Fragment>
                                                <Radio value='w2s'>仓到站 <Tooltip
                                                    title="从起运地到目的站由我司承运，从目的站到目的仓为贵司承运。">
                                                    <YgIcon type="icon-wenhaow"/>
                                                </Tooltip></Radio>
                                                <Radio value='p2s'>口岸到站 <Tooltip
                                                    title="从起运地到口岸为贵司承运，从口岸到目的站由我司承运，从目的站到目的仓由贵司承运。">
                                                    <YgIcon type="icon-wenhaow"/>
                                                </Tooltip></Radio>
                                                <Radio value='p2w'>口岸到仓 <Tooltip
                                                    title="从起运地到口岸为贵司承运，从口岸到目的仓由我司承运。">
                                                    <YgIcon type="icon-wenhaow"/>
                                                </Tooltip>
                                                </Radio>
                                            </Fragment> :
                                            <Fragment>
                                                <Radio value='w2s'>仓到站 <Tooltip
                                                    title="从起运地到转关地由我司承运，从转关地到目的仓为贵司承运。">
                                                    <YgIcon type="icon-wenhaow"/>
                                                </Tooltip></Radio>
                                                <Radio value='s2s'>站到站 <Tooltip
                                                    title="从起运地到口岸为贵司承运，从口岸到转关地由我司承运，从转关地到目的仓由贵司承运。">
                                                    <YgIcon type="icon-wenhaow"/>
                                                </Tooltip></Radio>
                                                <Radio value='s2w'>站到仓 <Tooltip
                                                    title="从起运地到口岸为贵司承运，从口岸到目的仓由我司承运。">
                                                    <YgIcon type="icon-wenhaow"/>
                                                </Tooltip></Radio>
                                            </Fragment>)
                                        : null}
                                    {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) ?
                                        <Fragment>
                                            <Radio value='w2p'>仓到口岸 <Tooltip
                                                title="从起运地到口岸为我司承运，从口岸到目的仓由贵司承运。">
                                                <YgIcon type="icon-wenhaow"/>
                                            </Tooltip>
                                            </Radio>
                                            <Radio value='p2p'>口岸服务 <Tooltip
                                                title="在口岸接收委托方货物，并根据客户要求完成出口报关、集装箱过境/倒装过境/境外倒装任务，由委托方自行完成境内外车辆调度及运输。">
                                                <YgIcon type="icon-wenhaow"/>
                                            </Tooltip>
                                            </Radio>
                                            <Radio value='s2w'>口岸到仓 <Tooltip
                                                title="从起运地到口岸为贵司承运，从口岸到目的仓由我司承运。">
                                                <YgIcon type="icon-wenhaow"/>
                                            </Tooltip>
                                            </Radio>
                                        </Fragment> : null}
                                    {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                                        <Fragment>
                                            <Radio value='w2as'>仓到启运机场 <Tooltip
                                                title="从起运地到启运机场为我司承运，从启运机场到目的仓为贵司承运。">
                                                <YgIcon type="icon-wenhaow"/>
                                            </Tooltip>
                                            </Radio>
                                            <Radio value='w2a'>仓到目的机场 <Tooltip
                                                title="从起运地到目的机场为我司承运，从目的机场到目的仓为贵司承运。">
                                                <YgIcon type="icon-wenhaow"/>
                                            </Tooltip>
                                            </Radio>
                                            <Radio value='p2p'>口岸服务 <Tooltip
                                                title="在口岸接收委托方货物，并根据客户要求完成出口报关、集装箱过境/倒装过境/境外倒装任务，由委托方自行完成境内外车辆调度及运输。">
                                                <YgIcon type="icon-wenhaow"/>
                                            </Tooltip>
                                            </Radio>
                                            <Radio value='p2as'>口岸到启运机场 <Tooltip
                                                title="从起运地到口岸为贵司承运，从口岸到启运机场为我司承运，从启运机场到目的仓为贵司承运。">
                                                <YgIcon type="icon-wenhaow"/>
                                            </Tooltip>
                                            </Radio>
                                            <Radio value='p2a'>口岸到目的机场 <Tooltip
                                                title="从起运地到口岸为贵司承运，从口岸到目的机场为我司承运，从目的机场到目的仓为贵司承运。">
                                                <YgIcon type="icon-wenhaow"/>
                                            </Tooltip>
                                            </Radio>
                                            <Radio value='p2w'>口岸到仓 <Tooltip
                                                title="从起运地到口岸为贵司承运，从口岸到目的仓为我司承运。">
                                                <YgIcon type="icon-wenhaow"/>
                                            </Tooltip>
                                            </Radio>
                                        </Fragment> : null}
                                </Radio.Group>)}
                                </Form.Item>
                            </Col>
                            {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) || (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && subType === 'A') ?
                                <Col span={24}>
                                    <Form.Item label="是否自备箱" {...{
                                        labelCol: {span: 6,},
                                        wrapperCol: {span: 18}
                                    }}>
                                        {getFieldDecorator('ownBox', {
                                            initialValue: ownBox,
                                            rules: [{required: true, message: '该项必填'}]
                                        })(<Radio.Group disabled={this.state.readOnly}
                                                        onChange={this.handOwnBox}
                                        >
                                            <Radio value='Y'>是</Radio>
                                            <Radio value='N'>否</Radio>
                                        </Radio.Group>)}
                                    </Form.Item>
                                </Col> : null}
                        </Row>
                        <Row>
                            <Col span={6}><span className="form-label">线路规划:</span></Col>
                            <Col span={18}>
                                <div className='route-planning'>
                                    <div className="column2">
                                        <div className="circle-line">
                                            <div
                                                className={transferType == 'w2w' || transferType == 'w2s' || transferType == 'w2p' || transferType == 'w2a' || transferType == 'w2as' ? 'circle-on' : 'circle'}>
                                                <span>仓</span>
                                            </div>
                                            <div
                                                className={transferType == 'w2w' || transferType == 'w2s' || transferType == 'w2p' || transferType == 'w2a' ? 'line-on' : 'line'}></div>
                                            <div>
                                                <div
                                                    className={transferType ? 'circle-on' : 'circle'}></div>
                                                <div
                                                    className="circle-text">{DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) && deliveryType !== 'D' ? '站' : '口岸'}</div>
                                            </div>
                                            {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                                                <Fragment>
                                                    {deliveryType === 'D' ?
                                                        <Fragment>
                                                            <div className='line-on'></div>
                                                            <div className='circle-on'></div>
                                                        </Fragment> : null}
                                                    <div className='line-on'></div>
                                                    <div className='circle-on'><span>站</span></div>
                                                    <div
                                                        className={transferType == 'w2w' || transferType == 's2w' ? 'line-on' : 'line'}></div>
                                                </Fragment> : null}
                                            {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) ?
                                                <Fragment>
                                                    <div
                                                        className={transferType == 'w2w' || transferType == 's2w' ? 'line-on' : 'line'}></div>
                                                    <div
                                                        className={transferType == 'w2w' || transferType == 's2w' ? 'circle-on' : 'circle'}></div>
                                                    <div
                                                        className={transferType == 'w2w' || transferType == 's2w' ? 'line-on' : 'line'}></div>
                                                </Fragment> : null}
                                            {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                                                <Fragment>
                                                    <div className='line-on'></div>
                                                    <div className='circle-on'></div>
                                                    <div
                                                        className={!(transferType == 'w2as' || transferType == 'p2as') ? 'line-on' : 'line'}></div>
                                                    <div
                                                        className={!(transferType == 'w2as' || transferType == 'p2as') ? 'circle-on' : 'circle'}></div>
                                                    <div
                                                        className={transferType == 'w2w' || transferType == 'p2w' ? 'line-on' : 'line'}></div>
                                                    <div
                                                        className={(transferType == 'w2w' || transferType == 's2w' || transferType == 'p2w') ? 'circle-on' : 'circle'}></div>
                                                    <div
                                                        className={(transferType == 'w2w' || transferType == 's2w' || transferType == 'p2w') ? 'line-on' : 'line'}></div>
                                                </Fragment> : null}
                                            <div
                                                className={(transferType == 'w2w' || transferType == 's2w' || transferType == 'p2w') ? 'circle-on' : 'circle'}>
                                                <span>仓</span></div>
                                        </div>
                                    </div>
                                    <div className="column3">
                                        <SelectAreaFormItem
                                            label='起运地'
                                            name="originCity"
                                            getFieldDecorator={getFieldDecorator}
                                            initialValue={this.state.originCity}
                                            handleChange={e => {
                                                handleChangeArea(this, 'originCity', e, 'originCountry', 'origin', null, 'boxRentStation')
                                            }}
                                            disabledOpt={this.state.readOnly}
                                            data={[...this.state['origin']]}
                                        />
                                        <SelectFormItem
                                            label={PLAN_DELIVERY_TYPE.hasOwnProperty(deliveryType) ? '起始站' : '出境口岸'}
                                            name="customsPort"
                                            getFieldDecorator={getFieldDecorator}
                                            initialValue={this.state.customsPort}
                                            required={true}
                                            data={this.state.customsPorts}
                                            dataValue='customsPortCode'
                                            dataContent='customsPortName'
                                            handleChange={value => this.handleCustomsPort(value)}
                                        />
                                        {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                                            <SelectAreaFormItem
                                                label='启运机场'
                                                name="airStartCity"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.airStartCity}
                                                disabledOpt={this.state.readOnly}
                                                data={this.state.airStart}
                                                handleChange={e => {
                                                    handleChangeArea(this, 'airStartCity', e, 'airStartCountry', 'airStart');
                                                }}
                                            /> : null}
                                        {deliveryType === 'D' ?
                                            <SelectAreaFormItem
                                                label='起始站'
                                                name="airStartCity"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.airStartCity}
                                                disabledOpt={this.state.readOnly}
                                                data={this.state.start}
                                                handleChange={e => {
                                                    handleChangeArea(this, 'airStartCity', e, 'airStartCountry', 'start');
                                                }}
                                            /> : null}
                                        {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                                            <SelectAreaFormItem
                                                label={PLAN_DELIVERY_TYPE.hasOwnProperty(deliveryType) || deliveryType === 'D' ? '目的站' : '转关地'}
                                                name="internationalEndCity"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.internationalEndCity}
                                                disabledOpt={this.state.readOnly}
                                                data={this.state.international}
                                                handleChange={e => {
                                                    handleChangeArea(this, 'internationalEndCity', e, 'internationalEndCountry', 'international');
                                                }}
                                            /> : null}
                                        {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                                            <SelectAreaFormItem
                                                label='目的机场'
                                                name="airEndCity"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.airEndCity}
                                                disabledOpt={this.state.readOnly}
                                                data={this.state.airEnd}
                                                handleChange={e => {
                                                    handleChangeArea(this, 'airEndCity', e, 'airEndCountry', 'airEnd');
                                                }}
                                            /> : null}
                                        {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) || DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                                            <SelectAreaFormItem
                                                label='清关地'
                                                name="customsClearanceCity"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.customsClearanceCity}
                                                disabledOpt={this.state.readOnly}
                                                data={this.state.customsClearance}
                                                handleChange={e => {
                                                    handleChangeArea(this, 'customsClearanceCity', e, 'customsClearanceCountry', 'customsClearance');
                                                }}
                                            /> : null}
                                        <SelectAreaFormItem
                                            label='目的地'
                                            name="destinationCity"
                                            getFieldDecorator={getFieldDecorator}
                                            initialValue={this.state.destinationCity}
                                            disabledOpt={this.state.readOnly}
                                            data={this.state.destination}
                                            handleChange={this.handleChangeDestination}
                                        />{/*<span>请选择目的地客服为您推荐最低价的还箱地</span>*/}
                                        {/*<div><span><p className="circle">0</p>呜呜网铁承运部分</span><span>客户自运部分</span></div>*/}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <span><span>其他信息:</span></span>
                        <div className='spaceInfo-content-info'>
                            {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) || (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && subType === 'A') ?
                                <Row>
                                    <Col span={8}>
                                        <SelectFormItem
                                            label='租箱地'
                                            name="boxRentStation"
                                            getFieldDecorator={getFieldDecorator}
                                            initialValue={this.state.boxRentStation}
                                            initialValueNull={true}
                                            required={true}
                                            disabledOpt={this.state.readOnly}
                                            data={this.state.rentBox}
                                            dataValue='content'
                                            handleChange={e => {
                                                handleChangeRentalBox(this, 'boxRentStation', e, 'rentBox')
                                            }}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <SelectFormItem
                                            label='还箱地'
                                            name="boxReturnStation"
                                            getFieldDecorator={getFieldDecorator}
                                            initialValue={this.state.boxReturnStation}
                                            initialValueNull={true}
                                            required={true}
                                            disabledOpt={this.state.readOnly}
                                            data={this.state.returnBox}
                                            dataValue='content'
                                            handleChange={e => {
                                                handleChangeRentalBox(this, 'boxReturnStation', e, 'returnBox')
                                            }}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="集装箱数">
                                            {getFieldDecorator('containerNum', {
                                                initialValue: this.state.containerNum,
                                                rules: [{required: true, message: '该项必填'}, {
                                                    pattern: /^[1-9]\d*$/, message: '必须为大于0的整数'
                                                }]
                                            })(<Input placeholder='集装箱数'
                                                      onChange={e => {
                                                          this.setState({containerNum: e.target.value})
                                                      }}
                                                      readOnly={this.state.readOnly}
                                                      addonAfter={<CabinetTypeSelect
                                                          deliveryType={deliveryType}
                                                          subType={subType}
                                                          initialValue={this.state.cabinetType}
                                                          getFieldDecorator={getFieldDecorator}
                                                          setFieldsValue={setFieldsValue}
                                                          disabled={this.state.readOnly}/>}
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row> : null}
                            <Row>
                                <Col span={16}>
                                    <SelectFormItem
                                        label='货物类型'
                                        name="declareMode"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.declareMode}
                                        required={true}
                                        disabledOpt={this.state.readOnly}
                                        data={this.state.declareModes}
                                        dataValue='businessCode'
                                        dataContent='businessName'
                                        handleChange={this.handleDeclareMode}
                                        layout={{labelCol: {span: 4}, wrapperCol: {span: 19}}}
                                    />
                                </Col>
                                {this.state.declareCityRequired ?
                                    <Col span={8}>
                                        <SelectFormItem
                                            label='报关地'
                                            name="declareCity"
                                            getFieldDecorator={getFieldDecorator}
                                            initialValue={this.state.declareCity}
                                            required={this.state.declareCityRequired}
                                            disabledOpt={this.state.readOnly}
                                            data={this.state.declareCities}
                                            dataValue='declareCity'
                                            dataContent='declareCityName'
                                        />
                                    </Col> : null}
                                {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && deliveryType !== 'M' && (transferType === 'w2w' || transferType === 's2w') ?
                                    <Col span={8}>
                                        <Form.Item label="车型">
                                            {getFieldDecorator('vehicleType', {
                                                initialValue: this.state.vehicleType,
                                                rules: [{required: true, message: '该项必填',},],
                                            })(<Select disabled={readOnly}>
                                                {convertToOptions(vehicleStock)}
                                            </Select>)}
                                        </Form.Item>
                                    </Col>
                                    : null}
                                <Col span={8}>
                                    <Form.Item label="保险">
                                        {getFieldDecorator('insureFeeType', {
                                            initialValue: insureFeeType ? insureFeeType : 'D',
                                            rules: [{required: true, message: '该项必填'}]
                                        })(<Radio.Group disabled={this.state.readOnly}>
                                            <Radio value='D'>我司代办</Radio>
                                            <Radio value='Z'>自办</Radio>
                                        </Radio.Group>)}
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="转关手续">
                                        {getFieldDecorator('transitFeeType', {
                                            initialValue: transitFeeType ? transitFeeType : 'D',
                                            rules: [{required: true, message: '该项必填'}]
                                        })(<Radio.Group disabled={this.state.readOnly}>
                                            <Radio value='D'>我司代办</Radio>
                                            <Radio value='Z'>自办</Radio>
                                        </Radio.Group>)}
                                    </Form.Item>
                                </Col>
                                {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) ?
                                    <Fragment>
                                        <Col span={8}>
                                            <Form.Item label="预计到达口岸" {...formItemLayout}>
                                                {getFieldDecorator(`estimatePortDt`, {
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<DatePicker format="YYYY-MM-DD HH" style={{width: '100%'}}
                                                               disabledDate={this.disabledStartDate}
                                                               disabledTime={this.disabledDateTime}
                                                               showTime={{defaultValue: moment(new Date().getHours() + 1, 'HH')}}
                                                               onChange={this.handleChangeEstimatePortDt}
                                                />)}
                                            </Form.Item>
                                        </Col>
                                        {this.state.restStock != null ?
                                            <Col span={8}>
                                                <Form.Item label="剩余舱位" {...formItemLayout}>
                                                    {getFieldDecorator('stock', {})(
                                                        <span>{this.state.restStock}</span>)}
                                                </Form.Item>
                                            </Col> : null}
                                    </Fragment> : null}
                                {TRAIN_PORT_DELIVERY_TYPE.hasOwnProperty(deliveryType) ?
                                    <Col span={8}>
                                        <Form.Item label="预计出境时间" {...formItemLayout}>
                                            {getFieldDecorator('leaveCountryDt', {
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<DatePicker format="YYYY-MM-DD" style={{width: '100%'}}
                                                           disabledDate={this.disabledLeaveCountryDt}
                                            />)}
                                        </Form.Item>
                                    </Col> : null}
                                {deliveryType == 'G' ?
                                    <Col span={8}>
                                        <Form.Item label="班次时间">
                                            {getFieldDecorator('trainDt', {
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<DatePicker format="YYYY-MM-DD" style={{width: '100%'}}
                                                           disabled={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col> : null}
                                {PLAN_DELIVERY_TYPE.hasOwnProperty(deliveryType) ?
                                    <Col span={8}>
                                        <Form.Item label="班次时间">
                                            {getFieldDecorator('planDt', {
                                                initialValue: this.state.planDt,
                                                rules: [{required: true, message: '该项必填',},],
                                            })(<Select>
                                                {convertToOptions(this.state.planList)}
                                            </Select>)}
                                        </Form.Item>
                                    </Col> : null}
                            </Row>
                        </div>
                    </div>
                    <div className="order-base-title">国内仓库信息
                        {secondPlace ? null : <Button onClick={e => this.setState({secondPlace: true})}>两地装柜</Button>}
                    </div>
                    <div className="order-spaceInfo-content">
                        <span><span>仓库联系人信息:</span></span>
                        <Select onChange={this.handledeliveryPlaceChange}
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                                disabled={this.state.readOnly}>
                            {deliveryPlaceData.map(delivery => (
                                <Option key={delivery.id} value={delivery.id}>{delivery.company}</Option>
                            ))}
                        </Select>
                        <div className='spaceInfo-content-info'>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="仓库地址" {...formItemLayout}>
                                        {getFieldDecorator('deliveryPlace', {
                                            initialValue: this.state.deliveryPlace,
                                            rules: [{required: whRequired, message: '该项必填'}],
                                        })(
                                            <Input onChange={e => {
                                                this.setState({deliveryPlace: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="仓库联系人" {...formItemLayout}>
                                        {getFieldDecorator('contact', {
                                            initialValue: this.state.contact,
                                            rules: [{required: whRequired, message: '该项必填'}],
                                        })(
                                            <Input onChange={e => {
                                                this.setState({contact: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="仓库联系方式" {...formItemLayout}>
                                        {getFieldDecorator('contactTel', {
                                            initialValue: this.state.contactTel,
                                            rules: [{required: whRequired, message: '该项必填'}],
                                        })(
                                            <Input onChange={e => {
                                                this.setState({contactTel: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="预计提货时间" {...formItemLayout}>
                                        {getFieldDecorator('deliveryEstimateDt', {
                                            rules: [{required: true, message: '该项必填'}],
                                        })(<DatePicker
                                            format="YYYY-MM-DD HH"
                                            onChange={this.onDateChange} style={{width: '100%'}}
                                            disabledDate={this.disabledStartDate}
                                            disabledTime={this.disabledDateTime}
                                            showTime={{defaultValue: moment(new Date().getHours() + 1, 'HH')}}
                                        />)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    {secondPlace ? <Fragment>
                        <div className="order-base-title">国内仓库信息2
                            {secondPlace ?
                                <Button onClick={e => this.setState({secondPlace: false})}>删除</Button> : null}
                        </div>
                        <div className="order-spaceInfo-content">
                            <span><span>仓库联系人信息:</span></span>
                            <Select onChange={this.handledeliveryPlaceChange2}
                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                    disabled={this.state.readOnly}>
                                {deliveryPlaceData.map(delivery => (
                                    <Option key={delivery.id} value={delivery.id}>{delivery.company}</Option>
                                ))}
                            </Select>
                            <div className='spaceInfo-content-info'>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label="仓库地址" {...formItemLayout}>
                                            {getFieldDecorator('deliveryPlace2', {
                                                initialValue: this.state.deliveryPlace2,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<Input readOnly={this.state.readOnly}/>,)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系方式" {...formItemLayout}>
                                            {getFieldDecorator('contactTel2', {
                                                initialValue: this.state.contactTel2,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<Input readOnly={this.state.readOnly}/>,)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系人" {...formItemLayout}>
                                            {getFieldDecorator('contact2', {
                                                initialValue: this.state.contact2,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<Input readOnly={this.state.readOnly}/>,)}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Fragment> : null}
                    <div className="order-base-title">清关仓库信息(通知方)
                        {!secondNotify && !readOnly ?
                            <Button onClick={e => this.setState({secondNotify: true})}>两地清关</Button> : null}
                    </div>
                    <div className="order-spaceInfo-content">
                        <span><span>清关仓库信息:</span></span>
                        <Select onChange={this.handlenotifyPartyChange}
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                                disabled={this.state.readOnly}>
                            {notifyPartyData.map(notify => (
                                <Option key={notify.id} value={notify.id}>{notify.company}</Option>
                            ))}
                        </Select>
                        <div className='spaceInfo-content-info'>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="仓库名称" {...formItemLayout}>
                                        {getFieldDecorator('notifyParty', {
                                            initialValue: this.state.notifyParty,
                                            rules: [{required: declareWhRequired, message: '该项必填'}],
                                        })(<Input onChange={e => {
                                                this.setState({notifyParty: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="仓库地址" {...formItemLayout}>
                                        {getFieldDecorator('notifyPartyAddr', {
                                            initialValue: this.state.notifyPartyAddr,
                                            rules: [{required: declareWhRequired, message: '该项必填'}],
                                        })(<Input onChange={e => {
                                                this.setState({notifyPartyAddr: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="仓库联系人" {...formItemLayout}>
                                        {getFieldDecorator('notifyPartyContact', {
                                            initialValue: this.state.notifyPartyContact,
                                            rules: [{required: declareWhRequired, message: '该项必填'}],
                                        })(<Input onChange={e => {
                                                this.setState({notifyPartyContact: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="仓库联系方式" {...formItemLayout}>
                                        {getFieldDecorator('notifyPartyTel', {
                                            initialValue: this.state.notifyPartyTel,
                                            rules: [{required: declareWhRequired, message: '该项必填'}],
                                        })(<Input onChange={e => {
                                                this.setState({notifyPartyTel: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="海关编码" {...formItemLayout}>
                                        {getFieldDecorator('notifyPartyCustomsCode', {
                                            initialValue: this.state.notifyPartyCustomsCode,
                                            rules: [{
                                                required: declareWhRequired && DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && deliveryType !== 'M',
                                                message: '该项必填'
                                            }]
                                        })(<Input readOnly={this.state.readOnly}/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    {secondNotify ? <Fragment>
                        <div className="order-base-title">清关仓库信息(通知方)2
                            {secondNotify && !readOnly ?
                                <Button onClick={e => this.setState({secondNotify: false})}>删除</Button> : null}
                        </div>
                        <div className="order-spaceInfo-content">
                            <span><span>清关仓库信息:</span></span>
                            <Select onChange={this.handlenotifyPartyChange2}
                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                    disabled={this.state.readOnly}>
                                {notifyPartyData.map(notify => (
                                    <Option key={notify.id} value={notify.id}>{notify.company}</Option>
                                ))}
                            </Select>
                            <div className='spaceInfo-content-info'>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label="仓库名称" {...formItemLayout}>
                                            {getFieldDecorator('notifyParty2', {
                                                initialValue: this.state.notifyParty2,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(
                                                <Input readOnly={this.state.readOnly}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库地址" {...formItemLayout}>
                                            {getFieldDecorator('notifyPartyAddr2', {
                                                initialValue: this.state.notifyPartyAddr2,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<Input readOnly={this.state.readOnly}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系人" {...formItemLayout}>
                                            {getFieldDecorator('notifyPartyContact2', {
                                                initialValue: this.state.notifyPartyContact2,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<Input readOnly={this.state.readOnly}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系方式" {...formItemLayout}>
                                            {getFieldDecorator('notifyPartyTel2', {
                                                initialValue: this.state.notifyPartyTel2,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<Input readOnly={this.state.readOnly}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="海关编码" {...formItemLayout}>
                                            {getFieldDecorator('notifyPartyCustomsCode2', {
                                                initialValue: this.state.notifyPartyCustomsCode2,
                                                rules: [{
                                                    required: DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && deliveryType !== 'M',
                                                    message: '该项必填'
                                                }]
                                            })(<Input readOnly={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Fragment> : null}
                    <div className="order-base-title">目的仓库信息(卸货仓)
                        <span style={{marginLeft: '10px'}}>
                            <Checkbox value="sameConsignee" disabled={this.state.readOnly}
                                      onChange={e => {
                                          this.handleChangeSame(e.target.checked)
                                      }}>同清关仓库</Checkbox>
                            {!secondConsignee && !readOnly ?
                                <Button onClick={e => this.setState({secondConsignee: true})}>两地卸货</Button> : null}
                        </span>
                    </div>
                    <div className="order-spaceInfo-content">
                        <span><span>目的仓库信息:</span></span>
                        <Select onChange={this.consigneeHandleChange}
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                                disabled={this.state.readOnly}>
                            {this.state.consigneeData.map(d => (
                                <Option key={d.id} value={d.id}>{d.company}</Option>
                            ))}
                        </Select>
                        <div className='spaceInfo-content-info'>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="仓库名称" {...formItemLayout}>
                                        {getFieldDecorator('consignee', {
                                            initialValue: this.state.consignee,
                                            rules: [{required: whRequired, message: '该项必填'}],
                                        })(<Input onChange={this.consigneeChange} readOnly={this.state.readOnly}/>)}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="仓库地址" {...formItemLayout}>
                                        {getFieldDecorator('consigneeAddr', {
                                            initialValue: this.state.consigneeAddr,
                                            rules: [{required: whRequired, message: '该项必填'}],
                                        })(<Input onChange={this.consigneeAddrChange} readOnly={this.state.readOnly}/>)}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="仓库联系人" {...formItemLayout}>
                                        {getFieldDecorator('consigneeContact', {
                                            initialValue: this.state.consigneeContact,
                                            rules: [{required: whRequired, message: '该项必填'}],
                                        })(<Input onChange={this.consigneeContactChange}
                                                  readOnly={this.state.readOnly}/>)}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="仓库联系方式" {...formItemLayout}>
                                        {getFieldDecorator('consigneeTel', {
                                            initialValue: this.state.consigneeTel,
                                            rules: [{required: whRequired, message: '该项必填'}],
                                        })(<Input onChange={this.consigneeTelChange} readOnly={this.state.readOnly}/>)}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="海关编码" {...formItemLayout}>
                                        {getFieldDecorator('consigneeCustomsCode', {
                                            initialValue: this.state.consigneeCustomsCode,
                                        })(<Input readOnly={this.state.readOnly}/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    {secondConsignee ? <Fragment>
                        <div className="order-base-title">目的仓库信息(卸货仓)2
                            {secondConsignee && !readOnly ?
                                <Button onClick={e => this.setState({secondConsignee: false})}>删除</Button> : null}
                        </div>
                        <div className="order-spaceInfo-content">
                            <span><span>目的仓库信息:</span></span>
                            <Select onChange={this.consigneeHandleChange2}
                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                    disabled={this.state.readOnly}>
                                {this.state.consigneeData.map(d => (
                                    <Option key={d.id} value={d.id}>{d.company}</Option>
                                ))}
                            </Select>
                            <div className='spaceInfo-content-info'>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label="仓库名称" {...formItemLayout}>
                                            {getFieldDecorator('consignee2', {
                                                initialValue: this.state.consignee2,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<Input readOnly={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库地址" {...formItemLayout}>
                                            {getFieldDecorator('consigneeAddr2', {
                                                initialValue: this.state.consigneeAddr2,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<Input readOnly={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系人" {...formItemLayout}>
                                            {getFieldDecorator('consigneeContact2', {
                                                initialValue: this.state.consigneeContact2,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<Input readOnly={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系方式" {...formItemLayout}>
                                            {getFieldDecorator('consigneeTel2', {
                                                initialValue: this.state.consigneeTel2,
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<Input readOnly={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="海关编码" {...formItemLayout}>
                                            {getFieldDecorator('consigneeCustomsCode2', {
                                                initialValue: this.state.consigneeCustomsCode2,
                                            })(<Input readOnly={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Fragment> : null}
                    {payFlag ? <Fragment>
                        <div className="order-base-title">支付凭证</div>
                        <div className="order-spaceInfo-content">
                            <Upload {...uploadProps} fileList={this.state.fileList}>
                                <Button disabled={this.state.fileList.length >= 1}><Icon type="upload"/> 上传</Button>
                            </Upload>
                        </div>
                    </Fragment> : null}
                    {/*   <TrackModel
                     previewVisiable={previewVisiable}
                     hideModal={ this.previewhideModal }
                     previewData={previewData}
                     />*/}
                    <div className="order-track-opt">
                        {this.state.readOnly ? null : <AuthButton authority="order_edit:order_save" type='primary'
                                                                  htmlType="submit">保存</AuthButton>}
                        {this.state.readOnly ? null :
                            <AuthPopconfirm title="是否确定保存并提交?" onConfirm={e => this.handleSubmit(e, 'Y')}>
                                <Button type='primary'>保存并提交</Button>
                            </AuthPopconfirm>}
                        {/* <AuthButton authority="order_edit:order_download" type='primary'
                         onClick={this.downloadPdf}>下载</AuthButton>*/}
                        {/*  <AuthButton authority="order_edit:order_view" type='primary'
                         onClick={this.previewShowModal}>预览</AuthButton>*/}
                        {!this.state.readOnly && this.state.restStock != null ?
                            <span> 保存后，请在{cancelTime}小时内提交订单，否则订单将自动取消</span> : null}
                    </div>
                </Form>
            </div>
        )
    }
}

const WrapMmsOrderTrack = Form.create()(OrderTrack)
export default WrapMmsOrderTrack